module.exports = __webpack_public_path__ + "sv.7aecb115.svg";